module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('lbl_customer_create_headline')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addcustomer($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_customer_name')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.name),
      expression: "customer.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "formControlName": "name"
    },
    domProps: {
      "value": (_vm.customer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_customer_code')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.code),
      expression: "customer.code"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "4",
      "type": "text",
      "id": "code",
      "formControlName": "code"
    },
    domProps: {
      "value": (_vm.customer.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group same-row-spaced-apart-aligned",
    staticStyle: {
      "margin-top": "2.5rem"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_customer_active')))]), _vm._v(" "), _c('app-switch', {
    attrs: {
      "autoSave": false,
      "isInList": false,
      "identification": "active"
    },
    model: {
      value: (_vm.customer.active),
      callback: function($$v) {
        _vm.customer.active = $$v
      },
      expression: "customer.active"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getTranslation('app_lbl_action_customer_create')) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getTranslation('app_lbl_action_cancel')) + "\n                    ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a9b21cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/customer/CustomerCreate.vue
// module id = 687
// module chunks = 0